import config from '../../config'
import { HTTP } from  '../../http'
import moment from 'moment'

const pageSize = 50;

export function queryStringParams(request) {
    let startDate = moment(request.startDate);
    startDate.set({h: 0, m: 0, s: 0});
    let endDate = moment(request.endDate);
    endDate.set({h: 23, m: 59, s: 59});

    request.startDate = startDate.format('YYYY-MM-DDTHH:mm:ss');
    request.endDate = endDate.format('YYYY-MM-DDTHH:mm:ss');
    const eventId = request.eventId == null || request.eventId == '' ? '' : `&eventId=${request.eventId}`;
    const paymentTypeId = request.paymentTypeId == null || request.paymentTypeId == '' ? '' : `&paymentTypeId=${request.paymentTypeId}`;
    let cashierId = '';
    if(request.cashier) {
        for (let index = 0; index < request.cashier.length; index++) {
            const element = request.cashier[index];
            cashierId+= `&cashierId=${element.cid}`
        }
    }
    const userId = request.userId == null || request.userId == '' ? '' : `&userId=${request.userId}`;
    const paymentStatus = request.paymentStatus == null || request.paymentStatus == '' ? '' : `&paymentStatus=${request.paymentStatus}`;
    const machineSerial = request.machineSerial == null || request.machineSerial == '' ? '' : `&machineSerial=${request.machineSerial}`;
    return `startDate=${request.startDate}&endDate=${request.endDate}${eventId}${paymentTypeId}${paymentStatus}${cashierId}${machineSerial}${userId}`;
}

export function queryStringParamsWithPage(request, page, pageSize) {
    return `${queryStringParams(request)}&page=${page}&pageSize=${pageSize}`;
}

export default {
    search: (request, page) => {
        const url = `${config.apiEndpoints.barOrderPaymentReportUri}search?${queryStringParamsWithPage(request, page, pageSize)}`;
        return new Promise((resolve, reject) => {
            HTTP.get(url)
            .then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    searchExport: (request) => {
        const url = `${config.apiEndpoints.barOrderPaymentReportUri}search/export?${queryStringParams(request)}`;
        return new Promise((resolve, reject) => {
            HTTP.get(url)
            .then((response)=>{
                let blob = new Blob([response.data], { type: 'text/csv' });
                let url = window.URL.createObjectURL(blob);
                resolve(url)
            }, (error)=>{
                reject(error)
            })
        })
    }
}